import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Option } from '../../engine/models/models';
import { BingImageResult, Value } from '../../models/BingImageResult';
import { Globals } from '../../services/globals';

@Component({
  selector: 'image-search-results.component',
  templateUrl: 'image-search-results.component.html',
  styleUrls: ['image-search-results.component.css']
})

export class ImageSearchResultsComponent implements AfterViewInit {

  thumbs: BingImageResult;
  mediaAssociations: Value[];

  searchCriteria: string;
  selectedThumb: Value;
  selectedOption: Option;
  @Output() associationCreated = new EventEmitter<Value>();
  @Output() associationRemoved = new EventEmitter<Value>();
  @Output() searchCriteriaUpdated = new EventEmitter<string>();
  @Output() associationChanged = new EventEmitter<Value>();

  @ViewChild("searchTextBox") searchTextBox: ElementRef;

  constructor(public globals: Globals) {
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchTextBox.nativeElement, 'input')
      .pipe(map((event: Event) => (event.target as HTMLInputElement).value))
      .pipe(debounceTime(2000))
      .pipe(distinctUntilChanged())
      .subscribe(data => {
        this.searchCriteriaUpdated.emit(this.searchCriteria);
      }
    );
  }

  updateAssociation(event: MatSlideToggleChange, thumb: Value) {
    thumb.optionId = this.selectedOption.optionId;

    if (!event.checked) {
      this.associationRemoved.emit(thumb);
      thumb.isSelected = false;
    } else {
      this.associationCreated.emit(thumb);
      thumb.isSelected = true;
    }
  }

  updateConfiguration(event: MatSlideToggleChange, thumb: Value, property: string) {

    thumb.optionId = this.selectedOption.optionId;

    switch (property) {
      case "primary":
        thumb.isPrimaryImage = event.checked;
        break;
      case "inplace":
        thumb.isShownInPlace = event.checked;
        break;
    }
    this.associationChanged.emit(thumb);
  }
}
